'use strict';
angular.module('theme').component('passwordReset', {
	bindings: {
		email: '<'
	},
	templateUrl: 'component/password-reset.html',
	controller: function(CustomerService, Toast) {
		var self = this;
		this.sending = false;

		this.reset = function() {
			// If email isn't valid, it will be undefined
			if (!self.email) {
				Toast.error('THEME.RESET_PASSWORD.EMAIL_ERROR');
				return;
			}

			self.sending = true;
			CustomerService.resetPassword(self.email).then(function () {
				self.sending = false;
				Toast.success('THEME.RESET_PASSWORD.SENT', {email: self.email});
			}, function (error) {
				self.sending = false;
				Toast.errorRaw(error);
			});
		};
	}
});
